import { getNotBoughtPictures, getProductForType, getTotalPicturesInCartByType, getUuidMap, hasPortraitSiblingProduct, } from "@/react/Webshop/utils/digitalPictureUtils";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useShoppingCart } from "@/react/Webshop/providers/ShoppingCartProvider";
import { Trans, useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import styled from "styled-components";
import Button from "@mui/material/Button";
import React from "react";
import { formatCurrency } from "@/react/utils";
import Icon from "@mui/material/Icon";
import PictureSetPictures from "./PictureSetPictures";
import ProductPriceInfoPopup from "@/react/Webshop/Mobile/Components/ProductPriceInfoPopup";
import makeStyles from "@mui/styles/makeStyles";
import { usePictureSets } from "@/react/Webshop/hooks/usePictureSets";
import useDigitalRebate from "@/react/Webshop/hooks/useDigitalRebate";
const useStyles = makeStyles((theme) => ({
    heading: {
        fontWeight: 300,
        fontSize: "30px",
        color: theme.palette.primary.dark,
    },
    subHeading: {
        color: theme.palette.primary.main,
        fontSize: "12px",
    },
    topContainer: { marginBottom: theme.spacing(2), textAlign: "center" },
    buyCompleteSetContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(2),
        lineHeight: "1.15em",
    },
    productName: {
        fontWeight: "bold",
    },
    numPictures: {
        fontStyle: "italic",
    },
    oldPrice: {
        color: "rgba(0, 0, 0, 0.6)",
        textDecoration: "line-through",
        marginRight: theme.spacing(1),
    },
    currentPrice: {
        color: theme.palette.secondary.main,
        fontWeight: "bold",
    },
}));
const PictureSetType = ({ type, pictureSet, toggleSetInCart, }) => {
    const classes = useStyles();
    const { qualifyForDigitalRebate } = useShoppingCart();
    const { pictureSets } = usePictureSets();
    const { getRebatedSetPriceByType } = useDigitalRebate();
    const { t } = useTranslation();
    const [showPriceDialog, setShowPriceDialog] = useState(null);
    const priceList = usePriceList();
    const settings = useMemo(() => {
        const portraitSiblingProductAvailable = hasPortraitSiblingProduct(priceList);
        return getUuidMap(portraitSiblingProductAvailable, t)[type];
    }, [priceList, type]);
    const singleFileProduct = getProductForType(priceList, settings, "singleFile");
    const pictureSetProduct = getProductForType(priceList, settings, "pictureSet");
    const pictures = getNotBoughtPictures(pictureSet, settings);
    //const boughtImagesOfType = pictures.filter((picture) => picture.inCart);
    const boughtImagesOfType = getTotalPicturesInCartByType(settings, pictureSets !== null && pictureSets !== void 0 ? pictureSets : []);
    let rebatedSetPrice = null;
    const digitalSetRebatedPrice = getRebatedSetPriceByType(type);
    const campaignPrice = pictureSetProduct === null || pictureSetProduct === void 0 ? void 0 : pictureSetProduct.productprices[0].campaignprice;
    const originalPrice = pictureSetProduct === null || pictureSetProduct === void 0 ? void 0 : pictureSetProduct.productprices[0].price;
    if (qualifyForDigitalRebate && digitalSetRebatedPrice !== null) {
        rebatedSetPrice = digitalSetRebatedPrice;
    }
    else if (campaignPrice) {
        rebatedSetPrice = campaignPrice;
    }
    let priceToPay = originalPrice;
    if (rebatedSetPrice) {
        priceToPay = rebatedSetPrice;
    }
    // Ignore if no pictures available to buy
    if (pictures.length === 0) {
        return null;
    }
    const pictureSetBought = settings.getSetIsBought(pictureSet);
    return (React.createElement(Box, { mb: 1 },
        React.createElement(Container, { maxWidth: "md", disableGutters: true },
            React.createElement(Card, { raised: false }, pictureSet && (React.createElement(CardContent, null,
                React.createElement("div", { className: classes.topContainer },
                    React.createElement("div", null,
                        React.createElement("div", { className: classes.heading }, settings.title)),
                    singleFileProduct &&
                        singleFileProduct.productprices.length > 1 && (React.createElement(Box, { display: "flex", justifyContent: "center" },
                        React.createElement(PricesContainer, { onClick: () => setShowPriceDialog(singleFileProduct) },
                            React.createElement(Icon, null, "info"),
                            React.createElement(Trans, null, "Prices")))),
                    !pictureSetProduct && (React.createElement("div", { className: classes.subHeading }, t("%d pictures", {
                        postProcess: "sprintf",
                        sprintf: [pictures.length],
                    })))),
                pictureSetProduct && (React.createElement(Box, { display: "flex", justifyContent: "space-between", mb: 2 },
                    !pictureSetBought && (React.createElement("div", { className: classes.buyCompleteSetContainer },
                        React.createElement("div", null,
                            React.createElement("div", { className: classes.productName }, pictureSetProduct.name),
                            React.createElement("div", { className: classes.numPictures }, t("%d pictures", {
                                postProcess: "sprintf",
                                sprintf: [pictures.length],
                            })),
                            React.createElement(Box, { display: "flex" },
                                rebatedSetPrice && (React.createElement("div", { className: classes.oldPrice }, formatCurrency(originalPrice))),
                                " ",
                                React.createElement("div", { className: classes.currentPrice }, formatCurrency(priceToPay)))))),
                    React.createElement(Box, null,
                        React.createElement(Button, { color: "primary", variant: "contained", onClick: () => toggleSetInCart(pictureSet, type) }, pictureSet.digitalSet[type].inCart ? (React.createElement(Trans, null, "Remove from cart")) : (React.createElement(Trans, null, "Buy digital file set")))))),
                pictures && singleFileProduct && (React.createElement(React.Fragment, null,
                    React.createElement(PictureSetPictures, { pictureSet: pictureSet, pictures: pictures, singleFileProduct: singleFileProduct, pictureSetProduct: pictureSetProduct, boughtImagesOfType: boughtImagesOfType, settings: settings, type: type })))))),
            showPriceDialog && (React.createElement(ProductPriceInfoPopup, { open: true, product: showPriceDialog, handleClose: () => setShowPriceDialog(null) })))));
};
const PricesContainer = styled.button `
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primary.dark.color};
  .material-icons {
    margin-right: 8px;
  }
`;
export default PictureSetType;
